import { VerificationStepConfigState } from "@idw-types/state";
import { CaptureModes } from "@enums/capture-modes";
import { VerificationStepConfigActions, VerificationStepConfigActionTypes } from "../actions/verification-step-config-actions";
import { CaptureStep } from "../../types/data/capture-step";

export const initialVerificationStepConfigState: VerificationStepConfigState = {
    initialized: false,
    captureSteps: null,
    responseToken: null,
    callbackurl: null,
    allStepsCompleted: false,
    currentStep: null,
    captureSaveSuccess: false,
    captureSaveError: false,
    isSubmittingCaptures: false,
    submitErrorMessage: null,
    redirectURL: null,
    useAuthIDCapture: false,
    captureMode: CaptureModes.NATIVE,
    captureStarted: false,
    isStartingCapture: false,
    facetecDeviceIdentifier: null,
    sharpnessFailureCount: 0
};

export const verificationStepConfigReducer = (state: VerificationStepConfigState = initialVerificationStepConfigState, action: VerificationStepConfigActions) => {
    switch (action.type) {
        case VerificationStepConfigActionTypes.INITIALIZE_VERIFICATION_STEP_CONFIG:
            return {
                ...state,
                captureSteps: action.payload.captureSteps,
                initialized: true
            };
        case VerificationStepConfigActionTypes.SET_IS_STARTING_CAPTURE:
            return {
                ...state,
                isStartingCapture: true,
                captureStarted: false,
            };
        case VerificationStepConfigActionTypes.SET_START_CAPTURE_SUCCESS:
            return {
                ...state,
                isStartingCapture: false,
                captureStarted: true,
                responseToken: action.payload.responseToken
            };
        case VerificationStepConfigActionTypes.SET_CAPTURE_MODE:
            return {
                ...state,
                captureMode: action.payload.captureMode
            };
        case VerificationStepConfigActionTypes.UPDATE_CAPTURE_STEP:
            return {
                ...state,
                captureSteps: updateCaptureStep(state.captureSteps, action.payload.captureStep)
            };
        case VerificationStepConfigActionTypes.SET_SHARPNESS_FAILURE_COUNT:
            return {
                ...state,
                sharpnessFailureCount: action.payload.sharpnessFailureCount
            };
        default:
            return state;
    }
};

const updateCaptureStep = (captureSteps: Array<CaptureStep>, captureStep: CaptureStep) => {
    return captureSteps.map(cs => cs.type === captureStep.type ? captureStep : cs);
};